/* eslint-disable linebreak-style */
/* eslint-disable eol-last */
/* eslint-disable linebreak-style */
// const merchantSchengen = {
//   code: 'schengen-insure',
//   currencySymbol: '$',
// };

const merchantAxa = {
  code: 'axa',
  currencySymbol: '$',
};

export default function getMerchant() {
  //return window.location.pathname === '/axa' || window.location.pathname.startsWith('/axa/') || window.location.pathname.startsWith('/website/axa/') ? merchantAxa : merchantSchengen;
  return merchantAxa;
}



// WEBPACK FOOTER //
// ./src/application/utils/getMerchant.js